import { indexData } from '@/mocks/tanhua';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按主题分类的探花资源索引，快速找到你喜欢的探花系列
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group flex items-center justify-between p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3 min-w-0">
                <span className={`inline-block w-2 h-2 rounded-full flex-shrink-0 ${
                  item.tag === '热门' || item.tag === '最热' || item.tag === '火爆'
                    ? 'bg-primary-500'
                    : item.tag === '新番' || item.tag === '推荐'
                    ? 'bg-accent-500'
                    : 'bg-secondary-400'
                }`}></span>
                <span className="text-sm md:text-base text-foreground-800 font-medium truncate">
                  {item.title}
                </span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}部</span>
                <span className="text-xs px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}